const planDetailElement = document.querySelector("[data-component='home-detail-data']");
const planDetailData = planDetailElement?.innerHTML
  ? JSON.parse(planDetailElement.innerHTML)
  : {};

if (planDetailData?.hasSelfGuidedTour) {
  require('./components/selfGuidedWidget');
}

require('features/segment');
require('./components/eventTracking/segmentEventsHandler');
require('features/googleAnalytics4');
require('./components/eventTracking/googleAnalytics4EventsHandler');
